import React from "react"

import styled from "styled-components"

import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import NumberFormat from "react-number-format"
import { FormattedMessage, Link } from "gatsby-plugin-intl"

const ResortDeals = ({ resort1, resort2 }) => {
  return (
    <Grid container>
      <ResortDeal
        key="resort1"
        title={resort1.footerTitle}
        subTitle={resort1.footerSubTitle}
        price={resort1.promoPrice}
        imageUrl={resort1.footerImage.fluid.src}
        position="right"
        resortUrl={resort1.slug}
      />
      <ResortDeal
        key="resort2"
        title={resort2.footerTitle}
        subTitle={resort2.footerSubTitle}
        price={resort2.promoPrice}
        imageUrl={resort2.footerImage.fluid.src}
        position="left"
        resortUrl={resort2.slug}
      />
    </Grid>
  )
}

export default ResortDeals

const ResortDeal = ({
  id,
  title,
  subTitle,
  price,
  imageUrl,
  position = "right",
  resortUrl,
}) => {
  
  return (
    <Contenedor item xs={12} sm={6}>
      <BackgroundImageDiv imageUrl={imageUrl} />

      <div className={"content " + position}>
        <div className="title">{title}</div>
        <div className="sub-title">{subTitle}</div>
        <div className="price">
        <FormattedMessage id="deals.locationItem.from" /> $
          <NumberFormat
            
            value={price}
            thousandSeparator={true}
            displayType={"text"}
            className="price"
          />
        </div>
        <Link to={'/'+resortUrl} className="button">
          <Button variant="contained" color="primary" className="button">
            <FormattedMessage id="global.footer.resortDeals.bookNow" />
          </Button>
        </Link>
      </div>
    </Contenedor>
  )
}

const Contenedor = styled(Grid)`
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: relative;
  min-height: 340px;

  .content {
    display: flex;
    top: 60px;

    flex-direction: column;
    align-items: center;
    position: absolute;
    color: white;
    font-weight: bold;
    text-shadow: black 1px 4px 5px;
    text-transform: uppercase;

    &.left {
      left: 50px;
    }

    &.right {
      right: 50px;
    }

    .title {
      font-size: 28px;
      line-height: 0.95;
    }

    .sub-title {
      font-size: 16px;
    }

    .price {
      font-size: 49px;
    }

    .button {
      text-decoration: none;
      border-radius: 0px;
      box-shadow: 0px 0px 0px 0px;
    }
  }
`

const BackgroundImageDiv = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-image: url(${props =>
    props.imageUrl
      ? props.imageUrl
      : "https://images.pexels.com/photos/40976/beach-beautiful-blue-coast-40976.jpeg"});
`
